export default __webpack_public_path__ + "static/media/dialog.ef2d2fe8.svg";